// Billing week helper. A week starts Monday 00:00 America/Guayaquil (UTC-5,
// no DST) and ends the following Monday 00:00. Mirrors backend
// `_billing_week_bounds` so the Cuentas cycle filter matches server logic.
// All timestamps are UTC ISO strings; cycles are computed in Ecuador time.
const ECU_OFFSET_MS = 5 * 60 * 60 * 1000; // UTC-5

const MONTHS = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

// Returns { key, label, start, end } for the Mon–Sun cycle containing `iso`.
// start/end are real UTC ISO strings; label shows the Ecuador wall-clock dates.
export function getBillingWeek(iso) {
  const d = iso ? new Date(iso) : new Date();
  if (isNaN(d.getTime())) return null;
  // Shift so the Date's UTC fields represent Ecuador wall time.
  const local = new Date(d.getTime() - ECU_OFFSET_MS);
  const dow = local.getUTCDay(); // 0=Sun..6=Sat
  const daysSinceMon = (dow + 6) % 7;
  const mon = new Date(Date.UTC(
    local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate() - daysSinceMon,
    0, 0, 0, 0
  ));
  const sun = new Date(mon.getTime() + 6 * 24 * 3600 * 1000); // Sunday (ECU wall)
  // Convert ECU wall-time boundaries back to real UTC.
  const startUTC = new Date(mon.getTime() + ECU_OFFSET_MS);
  const endUTC = new Date(mon.getTime() + 7 * 24 * 3600 * 1000 + ECU_OFFSET_MS); // next Monday 00:00
  const lbl = (dt) => `${dt.getUTCDate()} ${MONTHS[dt.getUTCMonth()]}`;
  const label = `${lbl(mon)} – ${lbl(sun)} ${sun.getUTCFullYear()}`;
  return { key: startUTC.toISOString(), label, start: startUTC.toISOString(), end: endUTC.toISOString() };
}

// True if tx.created_at falls inside the given week option.
export function isInWeek(iso, week) {
  if (!week) return true;
  return iso >= week.start && iso < week.end;
}

// Build a descending list of week options present in the transactions, always
// including the current week first.
export function buildWeekOptions(transactions) {
  const map = new Map();
  const cur = getBillingWeek(new Date().toISOString());
  if (cur) map.set(cur.key, cur);
  (transactions || []).forEach((t) => {
    const w = getBillingWeek(t.created_at);
    if (w && !map.has(w.key)) map.set(w.key, w);
  });
  return Array.from(map.values()).sort((a, b) => (a.key < b.key ? 1 : -1));
}
